export function readPaginationItems<T = any>(response: any): T[] {
  if (!response) {
    return [];
  }
  if (Array.isArray(response)) {
    return response;
  }

  const items = response.Items ?? response.items;
  return Array.isArray(items) ? items : [];
}

export function readPaginationCount(response: any): number {
  if (response == null) {
    return 0;
  }
  if (typeof response === "number") {
    return response;
  }

  const page = response.Page ?? response.page;
  if (page) {
    const pageCount = page.Count ?? page.count;
    if (pageCount != null && pageCount !== "") {
      return Number(pageCount) || 0;
    }
  }

  const topLevelCount = response.Count ?? response.count;
  if (topLevelCount != null && topLevelCount !== "") {
    return Number(topLevelCount) || 0;
  }

  return 0;
}

export function isPaginatedListResponse(response: any): boolean {
  if (!response || Array.isArray(response)) {
    return false;
  }

  return (
    response.Items != null ||
    response.items != null ||
    response.Count != null ||
    response.count != null ||
    response.Page != null ||
    response.page != null
  );
}
